import { createApiFetch } from '@mbbe/config';
import { getFirebaseAuth } from '../../lib/firebase';
import { customerSession } from '../../lib/sessions';

async function getAuthToken(): Promise<string | null> {
  const auth = getFirebaseAuth();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export const destekApiFetch = createApiFetch({ getAuthToken, getSessionSignal: () => customerSession.current.signal });
